import useOnAirShoppingLive from '@flight-workspace/common-client/src/hooks/useOnAirShoppingLive';
import useTravelUser from '@flight-workspace/common-client/src/hooks/useTravelUser';
import { nClick } from '@flight-workspace/common-client/src/util/nClick';
import WidgetComponent, { PageType, ServiceType } from '@travel-ui/my-widget';
import config from 'config/index';

interface IProps {
  pageType: PageType;
  nClickCodePrefix: string;
}

const MyWidget = ({ pageType, nClickCodePrefix }: IProps) => {
  const {
    loading: travelUserLoading,
    userTravelClub,
    gnbTravelUser,
  } = useTravelUser({
    nAuthWithUrlParam: config.nAuthWithUrlParam,
  });
  const { shoppingLiveLoading, onAirUrl } = useOnAirShoppingLive();

  const travelUser = gnbTravelUser
    ? {
        ...gnbTravelUser,
        couponCnt: userTravelClub.coupons.length,
        savingRate: userTravelClub.getMinSavingRate('flight'),
      }
    : undefined;
  const initExpanded = !!onAirUrl || (travelUser && travelUser.couponCnt > 0);

  if (shoppingLiveLoading || travelUserLoading) return null;

  return (
    <WidgetComponent
      service={ServiceType.FLIGHT}
      pageType={pageType}
      usePopup={false}
      travelUser={travelUser}
      onAirShoppingLiveUrl={onAirUrl}
      initExpanded={initExpanded}
      nClick={nClick}
      nClickCodePrefix={nClickCodePrefix}
    />
  );
};

export default MyWidget;
